import { observer } from 'mobx-react';
import { CheckboxRequirementType } from '.';

interface Props {
  checkboxRequirement: CheckboxRequirementType;
}

function CheckBox({ checkboxRequirement }: Props) {
  switch (checkboxRequirement) {
    case 'required':
      return (
        <th className="w-[40px] p-4">
          <div className="w-6 h-6 bg-gray-300 rounded"></div>
        </th>
      );
    case 'not-required':
      return <></>;
  }
}

export default observer(CheckBox);
